import { useMemo } from 'react';

import { TAttachment } from '@/models/chat.model';

import { StyledAttachmentList } from './MessageAttachmentsStyles';
import { getAttachmentRenderer, getMediaKey, TAttachmentRenderer } from '../../helpers';

type TMessageAttachmentsProps = {
  attachments?: TAttachment[];
};

type TRenderableAttachment = {
  attachment: TAttachment;
  Renderer: TAttachmentRenderer;
};

const MessageAttachments = ({ attachments }: TMessageAttachmentsProps) => {
  const renderable = useMemo(
    () =>
      (attachments ?? [])
        .map((attachment) => ({ attachment, Renderer: getAttachmentRenderer(attachment) }))
        .filter((item): item is TRenderableAttachment => Boolean(item.Renderer)),
    [attachments]
  );

  if (!renderable.length) return null;

  return (
    <StyledAttachmentList>
      {renderable.map(({ attachment, Renderer }) => (
        <Renderer key={`${attachment.type}-${getMediaKey(attachment.url)}`} attachment={attachment} />
      ))}
    </StyledAttachmentList>
  );
};

export default MessageAttachments;
